import { render, staticRenderFns } from "./project-add-electric.vue?vue&type=template&id=c05e80b8&scoped=true&"
import script from "./project-add-electric.vue?vue&type=script&lang=js&"
export * from "./project-add-electric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05e80b8",
  null
  
)

export default component.exports